/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Months_FebruaryInputs */

const es_months_february = /** @type {(inputs: Months_FebruaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Febrero`)
};

const en_months_february = /** @type {(inputs: Months_FebruaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`February`)
};

/**
* | output |
* | --- |
* | "February" |
*
* @param {Months_FebruaryInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const months_february = /** @type {((inputs?: Months_FebruaryInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Months_FebruaryInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_months_february(inputs)
	return en_months_february(inputs)
});
export { months_february as "months.february" }